var ProductCountdown = {
    START_DAY: 1,   // 0 Sunday, 1 Monday ... 6 Saturday
    START_HOUR: 9,
    START_MINUTE: 0,
    END_DAY: 3,
    END_HOUR: 9,
    END_MINUTE: 0,
    TICK_MS: 1000,
    TURKEY_UTC_OFFSET_MINUTES: 180,

    init: function () {
        ProductCountdown.update();
        setInterval(ProductCountdown.update, ProductCountdown.TICK_MS);
    },

    turkeyNow: function () {
        var now = new Date();

        return new Date(now.getTime() + ProductCountdown.TURKEY_UTC_OFFSET_MINUTES * 60000);
    },

    windowStart: function (now) {
        var day = now.getUTCDay();
        var diff = (day === 0) ? -6 : (ProductCountdown.START_DAY - day);

        return new Date(Date.UTC(
            now.getUTCFullYear(),
            now.getUTCMonth(),
            now.getUTCDate() + diff,
            ProductCountdown.START_HOUR, ProductCountdown.START_MINUTE, 0, 0
        ));
    },

    windowEnd: function (start) {
        var dayDiff = ProductCountdown.END_DAY - ProductCountdown.START_DAY;

        return new Date(Date.UTC(
            start.getUTCFullYear(),
            start.getUTCMonth(),
            start.getUTCDate() + dayDiff,
            ProductCountdown.END_HOUR, ProductCountdown.END_MINUTE, 0, 0
        ));
    },

    remainingMs: function () {
        var now = ProductCountdown.turkeyNow();
        var start = ProductCountdown.windowStart(now);
        var end = ProductCountdown.windowEnd(start);

        var nowMs = now.getTime();
        var startMs = start.getTime();
        var endMs = end.getTime();

        if (isNaN(nowMs) || isNaN(startMs) || isNaN(endMs)) {
            return null;
        }

        if (nowMs < startMs || nowMs >= endMs) {
            return null;
        }

        return endMs - nowMs;
    },

    padTwo: function (value) {
        return (value < 10 ? '0' : '') + value;
    },

    format: function (remaining) {
        var totalSeconds = Math.floor(remaining / 1000);

        var hours = Math.floor(totalSeconds / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        if (isNaN(hours) || isNaN(minutes) || isNaN(seconds)) {
            return null;
        }

        return ProductCountdown.padTwo(hours) + ':' + ProductCountdown.padTwo(minutes) + ':' + ProductCountdown.padTwo(seconds);
    },

    update: function () {
        var boxes = $('.product-countdown');

        if (boxes.length === 0) {
            return;
        }

        var remaining = ProductCountdown.remainingMs();

        if (remaining === null) {
            ProductCountdown.hide(boxes);
            return;
        }

        if (remaining < 1000) {
            ProductCountdown.hide(boxes);
            return;
        }

        var text = ProductCountdown.format(remaining);

        if (text === null || text.indexOf('NaN') !== -1) {
            ProductCountdown.hide(boxes);
            return;
        }

        boxes.removeAttr('style').addClass('is-visible');
        boxes.find('.product-countdown__time').text(text);
        boxes.siblings('.product-weekly-banner').css('display', 'none');
    },

    hide: function (boxes) {
        boxes.removeClass('is-visible').css('display', 'none');
        boxes.find('.product-countdown__time').text('');
        boxes.siblings('.product-weekly-banner').css('display', 'block');
    }
};

$(document).ready(ProductCountdown.init);
